module.exports = __webpack_public_path__ + "static/media/71.7e3eae2d.png";